/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AbortRequestBuilderRequestsMetadata, type AbortRequestBuilder } from './abort/index.js';
// @ts-ignore
import { CompleteRequestBuilderRequestsMetadata, type CompleteRequestBuilder } from './complete/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/audio/uploads/{audioInputId}
 */
export interface WithAudioInputItemRequestBuilder extends BaseRequestBuilder<WithAudioInputItemRequestBuilder> {
    /**
     * The abort property
     */
    get abort(): AbortRequestBuilder;
    /**
     * The complete property
     */
    get complete(): CompleteRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithAudioInputItemRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/audio/uploads/{audioInputId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithAudioInputItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithAudioInputItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    abort: {
        requestsMetadata: AbortRequestBuilderRequestsMetadata,
    },
    complete: {
        requestsMetadata: CompleteRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
